import { useAuthState, useQueryList } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { Scim } from './Scim'

export function ScimContainer() {
  const { scimProvisioningService } = useServices()
  const { partner } = useAuthState()
  const partnerId = partner?.id

  const [{ data, isLoading }, { nextPage, previousPage, refresh }] = useQueryList(
    scimProvisioningService.getScimApiKeys,
    { partnerId: partnerId || '' }
  )

  return (
    <Scim refresh={refresh} keysData={data} isLoading={isLoading} nextPage={nextPage} previousPage={previousPage} />
  )
}
